<div class="right-side p-5">
  <h2>ESG Compliance</h2>
  <div class="section">
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="mt-4">
      <div *ngFor="let section of responseData; let i = index" class="mb-4" [hidden]="i !== currentSectionIndex">
        <!--<section class="vh-10 gradient-custom">-->
        <!--<div class="container py-5 h-100">-->
        <!--<div class="row justify-content-center align-items-center h-100">-->
        <div class="row">
          <div class="col-md-12">
            <!--<div class="card shadow-2-strong card-registration" style="border-radius: 15px;">-->
            <!--<div class="card-body p-4 p-md-5">-->
            <!--<figure class="text-center mb-4">
              <figcaption class="blockquote-footer">
                <div class="text-center border-bottom">
                  <h2>
                    {{ section.sectionTitle }}
                  </h2>
                </div>
              </figcaption>
            </figure>-->
            <h2>
              {{ section.sectionTitle }}
            </h2>
            <hr />
            <div [formGroupName]="section.sectionTitle">
              <div *ngFor="let question of section.questions" class="mb-3">
                <ng-container [ngSwitch]="question.inputType">
                  <!-- Label Only (No Input Field) -->
                  <div *ngSwitchCase="'label'">
                    <h6 class="form-label">
                      {{ question.questionText }}
                    </h6>
                  </div>
                  <!-- Radio Button -->
                  <div *ngSwitchCase="'radio'">
                    <label class="form-label">

                      <!--{{ question.questionNumber }} : {{ question.questionText }}-->
                      &#10148;  {{ question.questionText }}
                    </label>
                    <div class="form-check" *ngFor="let option of question.optionsList">
                      <input type="radio" [formControlName]="'question_' + question.questionId"
                             [value]="option.value" class="form-check-input"
                             id="{{ 'radio_' + question.questionId + '_' + option.value }}" />
                      <label class="form-check-label"
                             for="{{ 'radio_' + question.questionId + '_' + option.value }}">
                        {{ option.label }}
                      </label>
                    </div>
                    <div *ngIf="hasError(section.sectionTitle, question.questionId, 'required')"
                         class="alert alert-danger">
                      This field is required.
                    </div>
                  </div>

                  <!-- Text Input -->
                  <div *ngSwitchCase="'text'">
                    <label class="form-label">

                      <!--{{ question.questionNumber }} : {{ question.questionText }}-->
                      &#10148; {{ question.questionText }}
                    </label>
                    <input type="text" (keypress)="numberOnly($event)" [formControlName]="'question_' + question.questionId" class="form-control" minLength="0" maxlength="7" />
                    <div *ngIf="hasError(section.sectionTitle, question.questionId, 'required')"
                         class="alert alert-danger">
                      This field is required.
                    </div>
                    <!--<div *ngIf="hasError(section.sectionTitle, question.questionId, 'minlength')"
                         class="text-danger">
                      Minimum length is {{ question.minLength }}.
                    </div>
                    <div *ngIf="hasError(section.sectionTitle, question.questionId, 'maxlength')"
                         class="text-danger">
                      Maximum length is {{ question.maxLength }}.
                    </div>-->



                  </div>




                  <!-- Dropdown -->
                  <div *ngSwitchCase="'dropdown'">
                    <label class="form-label">
                      {{ question.questionNumber }} : {{ question.questionText }}
                    </label>
                    <select [formControlName]="'question_' + question.questionId" class="form-select">
                      <option *ngFor="let option of question.optionsList" [value]="option.value">
                        {{ option.label }}
                      </option>
                    </select>
                    <div *ngIf="hasError(section.sectionTitle, question.questionId, 'required')"
                         class="alert alert-danger">
                      Please select an option.
                    </div>
                  </div>
                  <div *ngSwitchCase="'slider'">
                    <label class="form-label">
                      {{ question.questionNumber }} : {{ question.questionText }}
                    </label>

                    <input type="range"
                           [formControlName]="'question_' + question.questionId"
                           [min]="question.min"
                           [max]="question.max"
                           [step]="1000000"
                           class="form-range"
                           (input)="onSliderChange($event, section.sectionTitle, question.questionId)" />

                    <span class="ms-2">
                      {{ convertToWords(form.get(section.sectionTitle)?.get('question_' + question.questionId)?.value || 0) }}
                    </span>

                    <!-- Validation Messages -->
                    <div *ngIf="hasError(section.sectionTitle, question.questionId, 'required')" class="alert alert-danger">
                      This field is required.
                    </div>
                    <div *ngIf="hasError(section.sectionTitle, question.questionId, 'min')" class="alert alert-danger">
                      Value should be at least {{ question.min }}.
                    </div>
                    <div *ngIf="hasError(section.sectionTitle, question.questionId, 'max')" class="alert alert-danger">
                      Value should not exceed {{ question.max }}.
                    </div>
                  </div>

                  <!-- Multi-select -->
                  <div *ngSwitchCase="'multiselect'">
                    <mat-form-field appearance="fill" class="w-100">
                      <mat-select multiple
                                  placeholder="Select Options"
                                  [formControlName]="'question_' + question.questionId"
                                  [(ngModel)]="selectedObjects"
                                  [compareWith]="comparer">
                        <mat-option *ngFor="let el of question.optionsList" [value]="el">
                          {{ el.label }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>

                    <!-- Validation Messages -->
                    <div *ngIf="hasError(section.sectionTitle, question.questionId, 'required')" class="alert alert-danger mt-1">
                      At least one option must be selected.
                    </div>
                    <div *ngIf="hasError(section.sectionTitle, question.questionId, 'minlength')" class="alert alert-danger mt-1">
                      Select at least {{ question.minLength }} option(s).
                    </div>
                    <div *ngIf="hasError(section.sectionTitle, question.questionId, 'maxlength')" class="alert alert-danger mt-1">
                      You can select at most {{ question.maxLength }} option(s).
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>

            <!-- Navigation Buttons -->

            <div class="d-flex justify-content-between mt-4">
              <div *ngIf="isVisible">
                <button type="button" class="btn btn-secondary" (click)="previousSection()"
                        [disabled]="currentSectionIndex === 0">
                  Previous
                </button>
              </div>


              <button *ngIf="currentSectionIndex < responseData.length - 1" type="button" class="btn btn-primary"
                      (click)="nextSection()">
                Next
              </button>
            </div>

            <!-- Submit Button -->
            <div class="text-center mt-4" *ngIf="currentSectionIndex === responseData.length - 1">
              <button type="submit" class="btn btn-success">
                Submit
              </button>
            </div>

            <!--</div>-->
            <!--</div>-->
          </div>
        </div>
        <!--</div>-->
        <!--</section>-->
      </div>
    </form>

  </div>
</div>
